export default {"src":"/_next/static/media/as-is-160-point.bb25efe1.svg","height":63,"width":63,"blurWidth":0,"blurHeight":0};